import { ReactNode } from "react";
import { createPortal } from "react-dom";

type TPortalProps = {
  children: ReactNode;
  element?: HTMLElement;
  containerId?: string;
};

export const Portal = (props: TPortalProps) => {
  const { children, containerId, element = document.body } = props;

  const container = document.getElementById(containerId || "root");

  if (!container) return null;

  return createPortal(children, container || element);
};
